import type { ScopeId } from '@repo/shared';
import { http, refreshAccessToken } from './http.js';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface AuthUser {
  id: string;
  email: string;
  role: string;
  /** Display name (forward-compat field; may be absent in legacy tokens). */
  name?: string;
  /** Scope grants returned by /v1/auth/me (Wave 1a). Optional for backward compat
   *  with stale cached users that pre-date the grants field. */
  grants?: Record<ScopeId, boolean>;
}

export interface LoginResponse {
  access_token: string;
  expires_at: number;
  user: AuthUser;
}

export const login = (body: LoginRequest) =>
  http.post<LoginResponse>('/v1/auth/login', body).then((r) => r.data);

export const getMe = () => http.get<AuthUser>('/v1/auth/me').then((r) => r.data);

export const logout = () => http.post('/v1/auth/logout').then(() => undefined);

export const refreshToken = () => refreshAccessToken();
